// extracted by mini-css-extract-plugin
export var container = "Intro-module--container--931f3";
export var layout = "Intro-module--layout--f033c";
export var details = "Intro-module--details--e21c3";
export var detailsItem = "Intro-module--detailsItem--97819";
export var detailIcon = "Intro-module--detailIcon--913bb";
export var animation = "Intro-module--animation--fded1";